import React, { Component } from 'react';
class Footer extends Component {
    render() {
        const year = new Date().getFullYear();
        return (
            <footer className="footer-container" style={{ background: 'white' }}>
                <span>Copyright © {year} Interglobo. All rights reserved.</span>
            </footer>
        );
    }
}
export default Footer;
